import React from 'react'
import _ from 'lodash'
import {
  Typography,
  Grid,
  TextField,
  Button,
  CircularProgress,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import ImportDialog from './ImportDialog'
import AllImportedSpreadsheetsTable from './AllImportedSpreadsheetsTable'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { BASE_DATA, IMPORT_SURVEY } from './queries'

const useStyles = makeStyles((theme) => ({
  input: {
    '&::placeholder': {
      paddingLeft: '10px'
    }
  },
  button: {
    margin: '10px 0'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}))

function ImportScreen(props) {
  const classes = useStyles()
  const [fileName, setFileName] = React.useState('')
  const [file, setFile] = React.useState(null)
  const [surveyName, setSurveyName] = React.useState('')
  const [shouldDisplayDialog, setShouldDisplayDialog] = React.useState(false)
  const [surveys, setSurveys] = React.useState([])

  const { loading, error, data } = useQuery(BASE_DATA, {
    // pollInterval: 1000
  })
  const [importSurvey] = useMutation(IMPORT_SURVEY)

  const handleFileChange = (event) => {
    if (_.isEmpty(event.target.files)) return

    setFile(event.target.files[0])
    setFileName(event.target.files[0].name)
  }

  const handleImportFile = () => {
    importSurvey({
      variables: {
        file: file,
        surveyName: surveyName,
      },
    })
    setShouldDisplayDialog(true)
    setFile(null)
    setFileName('')
    setSurveyName('')
  }

  React.useEffect(() => {
    if (data && (!loading && _.isEmpty(surveys) || !_.isEqual(data, surveys)) ) {
      setSurveys(data.allSurveys)
    }
  }, [loading, data])

  return (
    <>
      <Grid container spacing={ 5 } justify="flex-start" alignItems="center">
        <Grid item xs={ 12 }>
          <Typography align="justify">
            Aqui você gerencia os questionários (planilhas) disponíveis no sistema.
            Clique em "Selecionar o arquivo" e siga as instruções.
          </Typography>
          {
            props.userProfile === 'administrator' && (
              <Typography align="justify">
                ATENÇÃO: note que todas as abas do arquivo a ser carregado devem ser
                EXATAMENTE no mesmo formato que o modelo em vigor.
                Consulte <a href={ process.env.REACT_APP_SPREADSHEET_DOWNLOAD_LINK }>
                  aqui
                </a> o modelo, e prepare antes seu arquivo.
              </Typography>
            )
          }
        </Grid>

        <Grid
          container
          item
          xs={ 12 }
          lg={ 10 }
          xl={ 7 }
          alignItems="center"
          className={ classes.buttonContainer }
        >
          <Grid item xs={ 12 } md={ 7 } lg= { 6 }>
            <TextField
              className={ classes.button }
              fullWidth
              placeholder="Identificação"
              value={ surveyName }
              onChange={ (event) => setSurveyName(event.target.value) }
              InputProps={{ classes: { input: classes.input  }}}
            />
          </Grid>

          <Grid item xs={ 12 } md={ 7 }lg={ 3 } alignItems="center" justifyContent="space-between">
            <input
              className={ classes.button }
              fullWidth
              style={{ display: 'none' }}
              type="file"
              id="contained-button-file"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              onChange={ handleFileChange }
            />
            <label htmlFor="contained-button-file">
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                startIcon={ <CloudUploadIcon /> }
                component="span"
              >
                {
                  fileName
                    ? fileName
                    :
                    <Typography style={{ fontWeight: 400 }}>
                      Selecione o arquivo
                    </Typography>
                }
              </Button>
            </label>
          </Grid>

          <Grid item xs={ 12 } lg= { 2 } md={ 7 }>
            <Button
              className={ classes.button }
              fullWidth
              variant="contained"
              color="primary"
              onClick={ handleImportFile }
              disabled={ !surveyName || !file }
            >
              Importar
            </Button>
          </Grid>
        </Grid>

        {
          shouldDisplayDialog && (
            <ImportDialog
              onClose={ () => setShouldDisplayDialog(false) }
              title="Importação em andamento"
            >
              Você poderá acompanhar o status da importação na coluna de status
              na tabela abaixo.
            </ImportDialog>
          )
        }

        <Grid item xs={ 12 } align="center">
          {
            loading
              ? <CircularProgress />
              : <AllImportedSpreadsheetsTable data={ surveys } />
          }
        </Grid>
      </Grid>
    </>
  )
}

export default ImportScreen
